export default class VideoHeader {
    constructor(element: HTMLElement) {
        const video = element.querySelector('video');
        const content = element.querySelector<HTMLElement>('.js-content')!;

        if (video) {
            content.style.opacity = '0';

            video.addEventListener('ended', () => {
                content.style.opacity = '1';
                video.style.opacity = '0';
            });
        }
    }

    static createFromSelector(selector: string) {
        return Array.from(document.querySelectorAll<HTMLElement>(selector)).map(container => {
            return new VideoHeader(container);
        });
    }
}
